export default __webpack_public_path__ + "static/media/redemption-icon.abe4cb9b.svg";